import React from "react";
import "./intro.css";

function Intro() {
  return (
    <div className="intro">
      <p className="Hello">Hello</p>
      <h1 className="title">
        I'm Garv Jain Software Developer and a UI Designer.
      </h1>
      <p className="about">
        {" "}
        A dynamic second-year engineering student based in Mumbai, with a
        passion for innovation and problem-solving. Equipped with a diverse
        skill set spanning computer languages and design, Garv is ready to
        embark on his professional journey. Eager to contribute to cutting-edge
        projects and make meaningful impacts, he seeks opportunities to apply
        his knowledge and creativity in real-world scenarios. Join Garv as he
        brings his technical prowess and fresh perspective to the forefront of
        the industry.
      </p>
    </div>
  );
}

export default Intro;
